/* eslint-disable no-console */
import router from './router'
import store from './store'
// const token = undefined;
// permission judge function
// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

const whiteList = ['/login']; // no redirect whitelist

router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) > -1) { // 在白名單中直接進入
    next()
  } else if (store.getters.token) {
    if (!store.getters.user || Object.keys(store.getters.user).length === 0) {
      store.dispatch('GetUserInfo').then(user => { // 拉取user_info
        if (store.getters.langList.length === 0) {
          store.dispatch('GetLangList').then(() => { // 拉取user_info
            next()
          });
        } else {
          next()
        }
      }).catch(() => {
        next({ path: '/login' })
      });
    } else {
      next()
    }
  } else {
    next({ path: '/login' })
  }
});

router.afterEach(() => {
});
